(function($) {
  'use strict';

  const promises = {
    dom: function() {
      this.$toggle = $('[data-promise]');
      this.$items = $('.promises__item');
    },

    toggleItem: function() {
      const _ = this;
      _.$toggle.click(function(event) {
        event.preventDefault();
        const $this = $(this);
        const $section = $this.closest('.promises');
        const $parent = $this.parent();
        const $content = $this.siblings('.promises__item-content');
        const id = $this.data('promise');
        const bg = $this.data('promise-bg');
        const color = $this.data('promise-color');

        if (!$parent.hasClass('active')) {
          $section.attr('data-mode', color).css('--promises-bg', bg);
          if ($(window).width() > jcms.breakpoints.fluid_medium) {
            $section.find('[data-promise-img]').fadeOut(800);
          }
          $section.find('[data-promise-img="' + id + '"]').fadeIn(800);
          if ($(window).width() > jcms.breakpoints.fluid_medium) {
            _.$items.find('.promises__item-content').slideUp(function() {
              _.$items.removeClass('active');
              ScrollTrigger.refresh();
            });
          }
          $content.slideDown(function() {
            $parent.addClass('active');
            ScrollTrigger.refresh();
          });
        }
        else if ($(window).width() <= jcms.breakpoints.fluid_medium) {
          $content.slideUp(function() {
            $parent.removeClass('active');
            ScrollTrigger.refresh();
          });
        }
      });
    },

    ready: function() {
      this.dom();
      this.toggleItem();
    }
  };

  $(function() { promises.ready(); });

})(jQuery);
